import { render, staticRenderFns } from "./BoardStoreItemModal.vue?vue&type=template&id=732ba4d2&"
import script from "./BoardStoreItemModal.vue?vue&type=script&lang=js&"
export * from "./BoardStoreItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports